import styled from "styled-components";
import { MainColor } from "../constant";

export const MainContainer = styled.div`
  max-width: 1400px;
  margin: 0px auto;
  padding: 20px;
  width: 100%;
  min-height: 100dvh;
  font-family: "Sarabun", sans-serif;
`;

export const ResContainer = styled.div`
  display: flex;
  gap: ${(props) => `${props.gap}px`};
  flex-wrap: wrap;
  align-items: ${(props) => (props.alignItems ? props.alignItems : "center")};
  justify-content: ${(props) =>
    props.justifyContent ? props.justifyContent : "center"};
`;

export const BlogContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  flex-direction: row;
  max-width: ${(props) => `${props.maxWidth}px`};

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 20px;
  }
`;

export const ColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  align-items: ${(props) => props.alignItems};
`;

export const Text = styled.div`
  font-size: ${(props) => `${props.fontSize}px`};
  color: ${(props) => props.color};
  @media (max-width: 768px) {
    font-size: ${(props) => `${props.fontSizeMb}px`};
  }
`;

export const MainText = styled.div`
  color: ${MainColor};
  font-weight: bold;
  font-size: ${(props) => (props.fs ? `${props.fs}px` : "18px")};
  text-indent: ${(props) => (props.indent ? "2.5em" : "")};
  text-align: ${(props) => props.align};
  margin-top: ${(props) => `${props.mt}px`};
  margin-bottom: ${(props) => `${props.mb}px`};
`;

export const SubText = styled.div`
  font-size: ${(props) => (props.fs ? `${props.fs}px` : "16px")};
  text-indent: ${(props) => (props.indent ? "2.5em" : "")};
  margin-top: ${(props) => `${props.mt}px`};
  margin-bottom: ${(props) => `${props.mb}px`};
  text-align: ${(props) => props.align};
`;

export const ResImage = styled.img`
  width: 100%;
  max-width: ${(props) => `${props.maxWidth}px`};
  height: auto;
  box-shadow: ${(props) =>
    props.shadow &&
    `rgba(100, 100, 111, 0.2) 0px
    7px 29px 0px`};

  border-radius: ${(props) => props.border && `10px`};
`;
